const data={
    bannerList:[//轮播
        {
            bannerid:"",
            imgUrl:require('assets/images/about/companyIntroduce/banner_one.png'),
            jumpUrl:"",
        }
    ],
    introduction:`       华略未来科技（重庆）有限公司是一家基于信息技术与人工智能的智慧食安方案提供商，位于中国.重庆。企业专注于食品安全领域，稳健经营、持续创新、开放合作，在智慧食品安全管理、智能终端等领域构筑了解决方案优势；为客户、监管部门提供极具竞争力的产品、方案和服务，并致力于用智慧科技守护舌尖上的安全，构建更美好的未来世界。
       华略依托集团母公司多年的校餐运营管理经验及完备的食堂物资集采集配体系，基于超过10年的，托管4000人以上学校食堂20余个，经营连锁、加盟、直营校园超市已达300个左右，统一配送学校食堂、超市物资的学校达1200余所的丰富经验总结，打造高效的团餐食品安全管理平台。采用互联网、大数据、人工智能、物联网等技术手段，通过构建供应链溯源系统、集采集配系统、食堂智能化管理、大数据监管、在线培训及网络宣传等系统平台，系统化、智能化的解决食堂精细化管理及食品安全管理。构建严密高效、社会共治的食品安全治理体系，推进食品溯源体制机制创新。
       华略拥有独立的软硬件自主研发能力，一直致力于食品安全管理、学校后勤保障服务信息化等相关方案和产品的研发和运营。已取得包括区域级食品安全管理系统、集采集配系统、食品溯源系统、大数据监管系统等在内的20余项软件著作权。
       华略（ValueTek）秉承以科技（Tek)创造价值（value)的理念，扎根食品安全领域；愿与伙伴一起，致力于提升食品安全水平、守护舌尖上的安全。`,
    
    conut:[//数量
        {
            num:"20",//数量
            unit:"所",//单位
            name:"运营超过4000人食堂",//名字
        },
        {
            num:"350",//数量
            unit:"个",//单位
            name:"直营校园超市",//名字
        },
        {
            num:"500",//数量
            unit:"家",//单位
            name:"签约各类物资市级代理",//名字
        },
        {
            num:"1200",//数量
            unit:"所",//单位
            name:"物资配送学校数量",//名字
        },
        {
            num:"20",//数量
            unit:"亿",//单位
            name:"年营业额",//名字
        }
    ],

    developmentHistory:[//
        {
            time:"2011年",//时间
            instructions:`渝教科贸成立
为学校、机关提供后勤服务`,//说明
            type:"top",//
            url:require('assets/images/about/companyIntroduce/history_1.png'),//
        },
        {
            time:"2013年",//时间
            instructions:`以重点招商企业入驻涪陵`,//说明
            type:"bootom",//
            url:require('assets/images/about/companyIntroduce/history_2.png'),//
        },
        {
            time:"2015年",//时间
            instructions:`更名渝教集团`,//说明
            type:"top",//
            url:require('assets/images/about/companyIntroduce/history_3.png'),//
        },
        {
            time:"2019年1月",//时间
            instructions:`华略公司成立
专注食品安全解决方案`,//说明
            type:"bootom",//
            url:require('assets/images/about/companyIntroduce/history_4.png'),//
        },
        {
            time:"2020年",//时间
            instructions:`完成石柱等3个区县食品安全
平台建设`,//说明
            type:"top",//
            url:require('assets/images/about/companyIntroduce/history_5.png'),//
        }
    ],
    
    honoraryCertificate:{//荣誉资质
        one:[
            {
                name:"企业信用AAA级",//
                url:require('assets/images/about/companyIntroduce/one_1.png'),//
            },
            {
                name:"电商扶贫示范企业",//
                url:require('assets/images/about/companyIntroduce/one_2.png'),//
            },
            {
                name:"教育服务优秀企业",//
                url:require('assets/images/about/companyIntroduce/one_3.png'),//
            },
            {
                name:"商贸服务十强企业",//
                url:require('assets/images/about/companyIntroduce/one_4.png'),//
            },
        ],
        two:[
            {
                name:"电信增值业务经营许可",//
                url:require('assets/images/about/companyIntroduce/two_1.png'),//
            },
            {
                name:"校园食品安全平台",//
                url:require('assets/images/about/companyIntroduce/two_2.png'),//
            },
            {
                name:"新闻发布系统",//
                url:require('assets/images/about/companyIntroduce/two_3.png'),//
            },
            {
                name:"校园安全综合管理系统",//
                url:require('assets/images/about/companyIntroduce/two_4.png'),//
            },
            {
                name:"后勤管理系统",//
                url:require('assets/images/about/companyIntroduce/two_5.png'),//
            },
            {
                name:"食安溯源系统",//
                url:require('assets/images/about/companyIntroduce/two_6.png'),//
            },
            {
                name:"在线学习系统",//
                url:require('assets/images/about/companyIntroduce/two_7.png'),//
            },
            {
                name:"教育公共服务系统",//
                url:require('assets/images/about/companyIntroduce/two_8.png'),//
            },
            {
                name:"智慧测评系统",//
                url:require('assets/images/about/companyIntroduce/two_9.png'),//
            },
            {
                name:"智慧课堂系统",//
                url:require('assets/images/about/companyIntroduce/two_10.png'),//
            },
        ],
    },
}

export default data;
